import React from "react";

import TestCaseForm from "./TestCaseForm.jsx";

const CreateTestCase = () => {

  return (
    <div className="awsui">
      <div className="awsui-util-container-header">
        <h1 className="awsui-text-large">
          Create Test Case
        </h1>
      </div>
      <div className="awsui-util-container">
        <TestCaseForm />
      </div>

    </div>
  );
};

export default CreateTestCase;


// WEBPACK FOOTER //
// ./src/components/CreateTestCase.jsx